import React from 'react';

import { Row, Col } from 'antd';

import Header from '../Header';
import Footer from './Footer';
import style from './DirectSourcing.module.scss';

export default function DirectSourcing() {
  return (
    <>
      <Header />
      <main className="typography">
        <section className={style.heroSection}>
          <div className="container">
            <h1 className="info-title underline">
              <span>
                DIR<span className="fake"></span>CT
              </span>{' '}
              SOURCING
            </h1>
            <div className={style.heroRow}>
              <div className={style.heroCol}>
                <div className={style.accent}>43%</div>
                of the average organization’s total workforce is comprised of
                non-employee labor
              </div>
              <div className={style.heroCol}>
                <div className={style.accent}>98%</div>
                of businesses state that their non-employee workforce is
                critical
              </div>
              <div className={style.heroCol}>
                <div className={style.accent}>5%</div>
                Contingent spend will be in the top 5% of spend categories by
                2025
              </div>
            </div>
            <h3 className="info-subtitle underline">
              The world is embarking on the contingent worker revolution. Those
              that lose ground in the war for talent will struggle to survive
              this shifting marketplace.
              <br />
              <br />
              Commonplace scenarios to consider:
            </h3>

            <ul className="default-list rectangle">
              <li>
                Steven’s team is understaffed and needs to fill every position.
                A prolonged hiring process with an antiquated training program
                increases the amount of time it takes to fill positions by 3-4x
              </li>
              <li>
                CHRO Tina is trying to manage a number of departments with
                consistently high turnover rates that expose her organization to
                increased employer burdens
              </li>
              <li>
                Bill, the VP of IT, is getting pressured by finance departments
                to reduce agency spend and eliminate non-critical positions
                while maintaining high productivity
              </li>
            </ul>

            <h3 className="info-subtitle underline">
              Securing talent is top of mind for any company at the forefront of
              innovation.
            </h3>

            <p>
              A workforce that can pivot with market and globalization demands
              will increase an organization’s competitive appeal, brand
              awareness and company elevation.
              <br />
              <br />
              In comes Direct Sourcing - a company that leverages its own
              internal candidate pool to place temporary employees within the
              organization. This helps organizations develop the agility needed
              to harness talent, operations and systems in an efficient,
              effective and cost-saving manner:
            </p>

            <ul className="default-list arrow">
              <li>Flexible and Non-committal terms</li>
              <li>
                Day One Cost Savings: shorter hiring cycles, streamlined
                onboarding, etc
              </li>
              <li>Top-tiered Skill Sets adept at delivering with deadlines</li>
              <li>Rapid Responsiveness to Market Fluctuations</li>
            </ul>
          </div>
        </section>
        <section className={style.infoSection}>
          <div className="container">
            <h3 className="info-subtitle underline">
              myBasePay offers a more immediate solution. Our Employer of Record
              and on-demand payroll platform allow you to implement a turnkey
              program with a customized approach:
            </h3>

            <Row gutter={[20, 40]}>
              <Col xs={24} sm={12} xl={8} className="d-flex">
                <div className="feature-card">
                  <div className="feature-text">Statutory Payroll Filings</div>
                </div>
              </Col>
              <Col xs={24} sm={12} xl={8} className="d-flex">
                <div className="feature-card">
                  <div className="feature-text">Document Maintenance</div>
                </div>
              </Col>
            </Row>
            <Row gutter={[20, 40]} justify="end">
              <Col xs={24} sm={12} xl={8} className="d-flex">
                <div className="feature-card">
                  <div className="feature-text">Lower Markups</div>
                </div>
              </Col>
              <Col xs={24} sm={12} xl={8} className="d-flex">
                <div className="feature-card">
                  <div className="feature-text">
                    Workforce Management Portals
                  </div>
                </div>
              </Col>
            </Row>
            <Row gutter={[20, 40]}>
              <Col xs={24} sm={12} xl={8} className="d-flex">
                <div className="feature-card">
                  <div className="feature-text">
                    Timesheet Collections and Oversight
                  </div>
                </div>
              </Col>
              <Col xs={24} sm={12} xl={8} className="d-flex">
                <div className="feature-card">
                  <div className="feature-text">Pre-employment Screenings</div>
                </div>
              </Col>
            </Row>
            <Row gutter={[20, 40]} justify="end">
              <Col xs={24} sm={12} xl={8} className="d-flex">
                <div className="feature-card">
                  <div className="feature-text">Customized Onboarding</div>
                </div>
              </Col>
            </Row>

            <ul className="default-list rectangle">
              <li>Compliant Screening Measures</li>
              <li>Timely Onboarding and Payroll Processing</li>
              <li>Tax Withholdings and Deposits</li>
              <li>Insurance Coverage for Assigned Employees</li>
              <li>Paid Time Off Eligiblity for ALL Full-Time Workers</li>
              <li>Administration of Employee Health Benefits</li>
              <li>Billing and Collections for all Worker Invoices</li>
            </ul>
          </div>
        </section>
        <section className={style.aboutSection}>
          <div className="container">
            <h3 className="info-subtitle underline">
              A turnkey solution to ensure your business's long-term economic
              sustainment
            </h3>
            <ul className="default-list arrow">
              <li>Ramp down headcount in times of distress</li>
              <li>Select from a trained candidate pool in times of growth</li>
              <li>Discover cost savings with built-in pricing</li>
            </ul>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
